var srand, rand;
(function () {
    var seed = Math.floor(Math.random() * 10000);
    
    srand = function (s) { seed = s; };
    
    rand = function () {
        var x = Math.sin(seed++) * 10000;
        return x - Math.floor(x);
    };
})();

